module.exports = __webpack_public_path__ + "img/readiness_score.41860b8d.svg";